import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-6 py-24">
      <div className="max-w-xl w-full">
        <Link
          to="/"
          className="font-ui text-white/40 hover:text-white/90 transition-colors duration-500"
          style={{ fontSize: "10px", letterSpacing: "0.4em" }}
          data-testid="about-back"
        >
          ← The Void
        </Link>

        <div
          className="mt-16 font-mono-void text-white/40"
          style={{ fontSize: "10px", letterSpacing: "0.5em", textTransform: "uppercase" }}
        >
          Origin
        </div>

        <h1
          className="mt-3 font-serif text-white/95"
          style={{
            fontSize: "clamp(32px, 4.4vw, 52px)",
            lineHeight: 1.02,
            fontVariationSettings: '"opsz" 144, "SOFT" 0, "WONK" 0',
          }}
        >
          Something you would never say out loud.
        </h1>

        <div className="mt-10 space-y-6 font-serif-body text-white/65" style={{ fontSize: "clamp(17px, 1.9vw, 21px)", lineHeight: 1.5 }}>
          <p>The Void is not a social network. It is not a product. It is a place.</p>
          <p>
            For one dollar you may whisper one thing — a fear, a desire, a rage, a
            regret, a secret — and it disappears.
          </p>
          <p>No name. No profile. No trace.</p>
          <p>
            Every message stays in the dark until{" "}
            <span className="font-mono-void text-white">1,000,000</span> have been
            whispered.
          </p>
          <p className="text-white/45">Then something happens.</p>
        </div>

        <div className="mt-20 font-mono-void text-white/30" style={{ fontSize: "10px", letterSpacing: "0.4em", textTransform: "uppercase" }}>
          Nobody reads what you write — until the count is complete.
        </div>
      </div>
    </div>
  );
}
